export default __webpack_public_path__ + "images/4ab8e8d7477af2186d42d44a3ec5ec9a-Rudy-looking.png";